import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificacionesSeguimientoService {
  
  // BehaviorSubject para el contador de notificaciones no leídas
  private contadorNoLeidasSubject = new BehaviorSubject<number>(0);
  
  constructor() {}

  /**
   * Observable del contador de notificaciones no leídas
   */
  getContadorNoLeidas(): Observable<number> {
    return this.contadorNoLeidasSubject.asObservable();
  }

  /**
   * Obtiene el valor actual del contador
   */
  getContadorActual(): number {
    return this.contadorNoLeidasSubject.value;
  }

  /**
   * Actualiza el contador de notificaciones no leídas
   */
  actualizarContador(cantidad: number): void {
    this.contadorNoLeidasSubject.next(cantidad);
  }

  /**
   * Decrementa el contador en 1
   */
  decrementarContador(): void {
    const valorActual = this.contadorNoLeidasSubject.value;
    if (valorActual > 0) {
      this.contadorNoLeidasSubject.next(valorActual - 1);
    }
  }

  /**
   * Incrementa el contador en 1
   */
  incrementarContador(): void {
    const valorActual = this.contadorNoLeidasSubject.value;
    this.contadorNoLeidasSubject.next(valorActual + 1);
  }
}
